import { DateTime } from "luxon"

export function parseDateTimeFromApi(value: string, locale?: string, zone?: string) {
    const localeToUse = locale ?? "da-DK"  // default to DK
    const zoneToUse = zone ?? "Europe/Copenhagen"  // database defaults to Cph zone

    // First we try the default API format
    let result = DateTime.fromSQL(value, { locale: localeToUse, zone: zoneToUse })
    if (!result.isValid) {
        // Fall back to ISO format
        result = DateTime.fromISO(value)
    }

    return result
}
